import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  OnInit,
  signal,
  TemplateRef,
  viewChild,
} from '@angular/core';
import { NgClass, NgOptimizedImage, NgTemplateOutlet } from '@angular/common';
import { ProgressSpinner } from 'primeng/progressspinner';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { PSDocumentPage } from '../../model/document-page.interface';
import { PSDocument } from '../../model/document.interface';
import { PageImageService } from '../../service/page-image.service';
import { BehandlerAssignmentData } from '../../model/behandler-assignment-data.interface';
import { BehandlerAssignmentService } from '../../behandler-assignment/behandler-assignment.service';
import { DocumentClassLabelPipe, TooltipOnContentOverflowDirective } from '@ps-gui/shared-core';

@Component({
  selector: 'shared-dp-preview-document-thumbnail',
  imports: [
    NgClass,
    NgTemplateOutlet,
    ProgressSpinner,
    TooltipOnContentOverflowDirective,
    NgOptimizedImage,
    DocumentClassLabelPipe,
  ],
  templateUrl: './preview-document-thumbnail.component.html',
  styleUrl: './preview-document-thumbnail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewDocumentThumbnailComponent implements OnInit {
  readonly typeThumbnail = input.required<PSDocumentPage>();
  readonly selected = input.required<boolean>();
  readonly document = input.required<PSDocument>();

  readonly documentLabelTemplate = input<TemplateRef<{ $implicit: PSDocument }>>();
  readonly documentThumbnailOverlayTemplate = input<TemplateRef<{ $implicit: PSDocument }>>();

  protected readonly label = viewChild<ElementRef>('labelElement');

  protected readonly pageImageService = inject(PageImageService);
  private readonly behandlerAssignmentService = inject(BehandlerAssignmentService);

  protected readonly behandlerAssignmentData = signal<BehandlerAssignmentData | undefined>(
    undefined,
  );

  constructor() {
    this.behandlerAssignmentService.behandlerAssignmentChanged
      .pipe(takeUntilDestroyed())
      .subscribe((documentId) => {
        if (documentId === this.document().id) {
          this.updateBehandlerAssignmentData();
        }
      });
  }

  ngOnInit() {
    this.updateBehandlerAssignmentData();
  }

  private updateBehandlerAssignmentData() {
    this.behandlerAssignmentData.set(this.document().behandlerAssignmentData);
  }
}
